export default __webpack_public_path__ + "static/media/health.3bc3e46f.png";